import { createGlobalStyle } from 'styled-components';

export const FolderTreeStyles = createGlobalStyle`
  .folder-tree {
    .folder-item {
      position: relative;

      &:hover {
        .folder-actions {
          opacity: 1;
        }
      }

      .folder-actions {
        opacity: 0;
        transition: opacity 0.2s ease;
      }
    }
  }

  .draggable-folder-tree {
    .folder-item {
      position: relative;

      &:hover {
        .folder-actions {
          opacity: 1;
        }
      }

      .folder-actions {
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      &.dragging {
        opacity: 0.6;
        transform: rotate(2deg);
      }
    }

    .drop-indicator {
      background: linear-gradient(to right, #007bff, #0056b3);
      height: 2px;
      border-radius: 1px;
      margin: 2px 0;
    }
  }

  /* Scrollbar styling for better appearance */
  .lists-sidebar,
  .folder-tree-container {
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 3px;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }

  /* Responsive behavior for mobile devices */
  @media (max-width: 768px) {
    .lists-sidebar {
      width: 100% !important;
      max-width: 320px;
    }

    .folder-tree {
      .folder-item {
        padding: 8px 12px;
        margin: 2px 0;
      }
    }
  }
`;

export default FolderTreeStyles;
